// tslint:disable:no-console
import * as jwtDecode from "jwt-decode";
import { put, takeLatest } from "redux-saga/effects";
import { getToken, removeToken } from "src/helpers";
import { getMyOpenTaks, getUser } from "src/redux/actions";
import { SagaIterator } from "@redux-saga/core";
import { IExtendedUser, IMyOpenTasks } from "src/common/types";
type FetchCurrentUser = SagaIterator | Promise<IExtendedUser>;
function* logoutUser() {
  yield put({ type: "FETCH_AUTH_TOKEN_REJECTED" });
  return removeToken();
}

function* fetchCurrentUser(): FetchCurrentUser {
  const token = getToken();
  if (token) {
    const { userId } = jwtDecode(token as string);
    const data = yield getUser(userId);

    yield put({ type: "GET_MY_OPEN_TASKS" });
    yield put({ type: "GET_CURRENT_USER_FULFILLED", payload: data });
  } else {
    yield logoutUser();
  }
}

function* fetchMyOpenTasks(): SagaIterator | Promise<IMyOpenTasks> {
  try {
    const payload = yield getMyOpenTaks();

    yield put({
      payload,
      type: "GET_MY_OPEN_TASKS_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      type: "GET_MY_OPEN_TASKS_REJECTED"
    });
  }
}

export default function* currentUserWatcher() {
  yield takeLatest("GET_CURRENT_USER", fetchCurrentUser);

  // My Open Tasks
  yield takeLatest("GET_MY_EMPLOYEES_LIST", fetchMyOpenTasks);
  yield takeLatest("GET_FEEDBACK_LIST", fetchMyOpenTasks);
  yield takeLatest("GET_MY_OPEN_TASKS", fetchMyOpenTasks);
  yield takeLatest("GET_MY_PEERS_LIST", fetchMyOpenTasks);
  yield takeLatest("REFETCH_MY_PEER_QUESTIONNAIRE", fetchMyOpenTasks);
  yield takeLatest("REFETCH_MY_QUESTIONNAIRE", fetchMyOpenTasks);
  yield takeLatest("REFETCH_TALK_SHEET", fetchMyOpenTasks);
}
